import { matchPath } from 'react-router-dom';
import { privateRoutes } from './private';
import { publicRoutes } from './public';

const getEffectivePath = (hash: string, pathname: string) =>
  hash ? hash.replace(/^#/, '') || '/' : pathname;

export const isPublicPath = (path: string) =>
  publicRoutes.some((r) => r.path && matchPath({ path: r.path, end: r.exact ?? false }, path));

export const isPrivatePath = (path: string) =>
  privateRoutes.some((r) => r.path && matchPath({ path: r.path, end: r.exact ?? false }, path));

export const getEffectivePathFromWindow = (pathname: string) =>
  getEffectivePath(window.location.hash, pathname);
